'use strict';

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _ajax = require('linksoft/utils/ajax');

var _ajax2 = _interopRequireDefault(_ajax);

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

var _notify = require('linksoft/notify');

var _notify2 = _interopRequireDefault(_notify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var resx = (0, _localize2.default)("App", "Common");

(0, _jquery2.default)(document).on('click', '.dataTable [data-control-button-is-newsletter]', function () {
    var $btn = (0, _jquery2.default)(this);
    var itemId = $btn.attr('data-control-button-is-newsletter-item-id');
    var isNewsletterFilter = $btn.attr('data-control-button-is-newsletter') === 'true';
    if (!itemId) return false;
    var $table = $btn.closest('.dataTable');
    if ($table.length > 0) {
        var api = $table.DataTable();
        var url = correctUrl(api.init().ajax.url);
        var patchUrl = url + '(' + itemId + ')';
        (0, _ajax2.default)({
            url: patchUrl,
            method: 'PATCH',
            data: JSON.stringify({ "isNewsletterFilter": !isNewsletterFilter }),
            contentType: 'application/json; charset=UTF-8'
        }).done(function (result) {
            _notify2.default.success(resx.Common.UpdateSuccess);
            api.ajax.reload(null, false);
        }).fail(function (result) {
            var msg = getBadRequestErrorMessage(result);
            _notify2.default.error(msg);
            api.ajax.reload(null, false);
        });
    }
    return false;
});

var correctUrl = function correctUrl(url) {
    var correctUrl = url;
    if (url.indexOf('?') > -1) {
        correctUrl = url.substring(0, url.indexOf('?'));
    }
    return correctUrl;
};


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/isNewsletterFilter.js
// module id = 440
// module chunks = 0